import { useTranslation } from 'next-i18next'

import { CategoryColorClasses } from '~/bootcamp/constants/bootcamp.const'
import { selectVideoTopicColor } from '~/bootcamp/slices/vcc-data.slice'
import { useAppSelector } from '~/redux/hooks'
import { isDecimalSumComplete } from '~/bootcamp/Activities/utils/activities.utils'

export default function DecimalPlacementMessage({
  answerValues,
  decimalIndex,
  isDecimalError,
}: {
  answerValues: Record<string, string>
  decimalIndex?: number
  isDecimalError?: boolean
}): React.ReactElement {
  const { t } = useTranslation('bootcamp')
  const colorInfo: CategoryColorClasses = useAppSelector(selectVideoTopicColor)

  const message = isDecimalError
    ? t('decimalPlacement.misplaced')
    : isDecimalSumComplete(answerValues) && decimalIndex === undefined
    ? t('decimalPlacement.prompt')
    : ''

  // Fixed height: this line comes and goes as the pupil works, and a calculation that jumps up
  // and down under their finger is worse than an empty line.
  return (
    <p
      className={`flex h-5 w-full items-center justify-center text-xs font-semibold ${
        isDecimalError ? 'text-red' : colorInfo.textClass
      }`}
    >
      {message}
    </p>
  )
}
